module.exports = __webpack_public_path__ + "static/cmu_logo-7b82720ff59f43d7a5de70f56a8ee24c.png";